function WithoutCashback(props) {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" 
            {...props}
            width={props.size ? props.size : 23.316} height={props.size ? props.size : 23.316} 
            viewBox="0 0 24 24" 
        >
            <path 
                fill="none"
                stroke={props.color ? props.color : "#f6f9fc"}    
                d="M1,19V5c0-1.7,1.3-3,3-3h16c0.6,0,1,0.4,1,1s-0.4,1-1,1H4C3.4,4,3,4.4,3,5s0.4,1,1,1h16c0.6,0,1,0.4,1,1v3c0,0.6-0.4,1-1,1
                s-1-0.4-1-1V8H4C3.7,8,3.3,7.9,3,7.8V19c0,0.6,0.4,1,1,1h8c0.6,0,1,0.4,1,1s-0.4,1-1,1H4C2.3,22,1,20.7,1,19z M18.9,16.5l1.8-1.8
                c0.4-0.4,0.4-1,0-1.4c-0.4-0.4-1-0.4-1.4,0L17.5,15l-1.8-1.8c-0.4-0.4-1-0.4-1.4,0c-0.4,0.4-0.4,1,0,1.4l1.8,1.8l-1.8,1.8
                c-0.4,0.4-0.4,1,0,1.4c0.4,0.4,1,0.4,1.4,0c0,0,0,0,0,0l1.8-1.8l1.8,1.8c0.4,0.4,1,0.4,1.4,0c0.4-0.4,0.4-1,0-1.4L18.9,16.5z"
            />
        </svg>
    );
};
export default WithoutCashback;